module.exports = __webpack_public_path__ + "static/media/7.question.0014b313.mp4";